<div class="modal fade" :id="modalComponentId" tabindex="-1" role="dialog" :aria-labelledby="modalComponentId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" :id="modalComponentId + 'Label'">{{modalHeading}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="onOkClick">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div v-if="!loading">
                    <div v-if="trackingHistory === null || trackingHistory.length === 0">
                        No Tracking History Found
                    </div>
                    <div v-if="trackingHistory !== null && trackingHistory.length > 0">
                        <p v-for="history in trackingHistory">
                            {{history.trackingDate}} - {{history.comment}}
                        </p>
                    </div>
                    
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" data-dismiss="modal" @click="onOkClick" :disabled="loading">OK</button>
            </div>
        </div>
    </div>
</div>